<template>
  <div class="user" :key="$store.state.loginStateKey">
    <div class="no_login" v-show="!$FN.getUser()">
      <div class="login_col">
        <div @click="$FN.visibleLogin(1)">
          <i class="iconfont icon-pes_icon_line_yonghuming" />
          <div class="text">{{ t('header.login') }}</div>
        </div>
      </div>
      <div class="login_col">
        <div @click="$FN.visibleLogin(3)">
          <i class="iconfont icon-pes_icon_line_yonghuming" />
          <div class="text">{{ t('header.register') }}</div>
        </div>
      </div>
    </div>
    <a-dropdown v-show="$FN.getUser()">
      <div class="user_name_information">
        <div>
          <i class="iconfont icon-pes_icon_piece_touxiang1">
            <span v-if="mode" class="vip_whole" :style="{background:limitsAuthority[mode].color}"><i :class="`iconfont ${limitsAuthority[mode].icon}`" /></span>
          </i>
        </div>
        <div>
          <span :key="key">{{ helloText }}<i class="iconfont icon-wjjf_icon_line_arrow_down" /></span>
        </div>
      </div>
      <a-menu class="antd_menu" slot="overlay">
        <a-menu-item key="1" @click="skip('/individualCenter/settings','individualCenter_settings')">{{ t('header.settings') }}</a-menu-item>
        <a-menu-item key="2" @click="skip('/individualCenter/collect','individualCenter_collect')">{{ t('header.myCollection') }}</a-menu-item>
        <a-menu-item key="3" @click="skip('/individualCenter/myOrder','individualCenter_myOrder')">{{ t('header.myOrder') }}</a-menu-item>
        <a-menu-item key="4" v-if="$FN.limitsVisible(['individualCenter_orderManagement'])" @click="skip('/individualCenter/orderManage','individualCenter_orderManagement')">{{ t('header.orderManage') }}</a-menu-item>
        <a-menu-item key="5" @click="logout"><a-spin :spinning="logoutLoading">{{ t('header.logout') }}</a-spin></a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import { t } from '@/locales';

export default {
  data() {
    return {
      key: 0, //当个人中心用户更新时，用来刷新此处用户名称
      mode: null,
      logoutLoading: false,
      limitsAuthority: {}
    }
  },
  computed: {
    helloText() {
      const name = this.$FN.check(this.$FN.getUser(), 'user.nickName') || '';
      const lang = this.$store.state.language;
      // 英文: Hello name / 中文: name,您好
      if (lang === 'english') {
        return `${t('header.hello')} ${name}`;
      }
      return `${name},${t('header.hello')}`;
    }
  },
  watch: {
    '$store.state.language'() {
      this.key = Math.random();
    }
  },
  created() {
    this.setMode();
    this.setLimits();
    this.getBus();
  },
  methods: {
    t,
    getBus() {
      this.$BUS.$on('updateUser', () => this.key = Math.random());
    },
    skip(route = null, rolesKey = null) {
      route && this.$FN.limitsTips({ list: [rolesKey] }).then(res => {
        if (res) {
          this.$router.$push(route)
        }
      })
    },
    logout() {
      this.logoutLoading = true;
      let header = { Authorization: this.$FN.getUser().newToken }
      let config = { method: "delete" };
      this.$FN.get("open/auth/logout", {}, config, header).then(res => {
        this.logoutLoading = false;
        if (res) {
          let { code = 500, msg = null } = res;
          if (code === 100) {
            this.$FN.logout();
            this.$FN.getRoles();
          } else {
            this.$message.error(msg)
          }
        }
      });
    },
    setLimits() {
      this.limitsAuthority = {
        // try: {
        //   name: "试用vip",
        //   icon: "icon-pes_icon_piece_shiyongVIPwenzi",
        //   color: "#AE2024"
        // },
        vip: {
          name: "企业vip",
          icon: "icon-pes_icon_piece_qiyeVIPwenzi",
          color: "#0068B7"
        },
        expired: {
          name: "企业过期vip",
          icon: "icon-pes_icon_piece_qiyeVIPwenzi",
          color: "#cdcdcd"
        }
      }
    },
    setMode() {
      if (!this.$FN.getUser()) return;
      let { userAttribute = null } = this.$FN.getUser();
      if (userAttribute) {
        let { enterpriseFlag = "0", vipFlag = "0" } = userAttribute;
        // enterpriseFlag 是否是企业 vipFlag 是否是vip

        // 是企业
        if (Number(enterpriseFlag)) {
          // 是vip
          if (Number(vipFlag)) {
            this.mode = "vip"
          } else {
            // 不是vip
            this.mode = "expired"
          }
        };
      };
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
<style lang="less" scoped>
body {
  .antd_menu {
    margin-top: 5px;
    padding: 5px;
    .ant-dropdown-menu-item {
      text-align: center;
      .pub_font_size();
      // border-bottom: 1px solid #dfdfdf;
    }
    .ant-dropdown-menu-item:hover {
      background: rgba(0, 0, 0, 0);
    }
    // .ant-dropdown-menu-item:last-child {
    //   border: 0;
    // }
    .ant-dropdown-menu-item-active {
      color: @primary-color;
      font-weight: bold;
    }
  }
}
</style>
